import React, { useState, useEffect } from 'react'
// import UserContext from '../context/UserContext'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col' 
import './ImageViewPanel.css'
import ConfirmDialog from './ConfirmDialog';

// props:
// images: array of image objects to display


function ImageViewPanel(props) {
    // note additional "dummy" parameters in URLs for PPTX and downloading images. Read this article below
    // https://www.hacksoft.io/blog/handle-images-cors-error-in-chrome#solution
    // TL;DR:
    // Problem:
    // If you've loaded an image in Chrome, Edge, Chromium or other Chromium-based browser, and the browser cached that image. When you call for that same image with the Access-Controll-Allow-Origin header (or crossOrigin="Anonymous" if you're doing it in JavaScript) - Chromium returns an error response because the initially cached image didn't have that header.
    // Solution:
    // When calling the image url with the crossOrigin="Anonymous" header, add a dummy GET parameter at the end of the URL. This will essentially change the resource, so Chrome won't look into the cache and will call the "new" url instead, giving you the image that you needed, but this time with the header that you wanted.
    // This solution not only fixes the issue in Chromium based browsers, but also doesn't change the way Firefox, Safari and other browsers view your app.
    
    // const userCtx = useContext(UserContext)
    const baseURL = process.env.REACT_APP_MODE === "PROD" ? process.env.REACT_APP_API_URL_PROD : process.env.REACT_APP_API_URL_TEST
    
    const [confirmDialogParams, setConfirmDialogParams] = useState({show:false})

    // const imageURL = (filename, patient_id) => `${baseURL}file_uploads/image/normal_${filename}?patient_id=${patient_id}&dict_company_code_id=${companyCtx.company.id}`


    const selectImageURL = (img) => {
        return `${baseURL}inventory_images/image/${img.file_name}?inventory_id=${img.inventory_id}`
    }

    
    const [combinedState, setCombinedState] = useState([]);
    const [columnCount, setColumnCount] = useState(1)
    // const [enableButtons, setEnableButtons] = useState(true)

    useEffect(() => {

        let combinedImages = props.images.sort((a,b) => new Date(a?.updated_at) - new Date(b?.updated_at))
        // add slected property for each image
        combinedImages = combinedImages.map(img => {
            return {...img, selected: true}
        })

        // if number of images >= 4 output in 4 columns; otherwise output in one row
        const splitSize2 = props.images.length >= 4 ? 4: props.images.length
        setColumnCount(splitSize2)
        let combinedImagesSorted = []
        for (let i = 0; i < combinedImages.length; i += splitSize2) {
            combinedImagesSorted.push(combinedImages.slice(i, i + splitSize2));
        }

        setCombinedState([...combinedImagesSorted])


        // console.log("combinedImagesSorted", [...combinedImagesSorted])
    }, [props.images, props.images.length])




    const getSelectedImagesList = (images) => {
        let selectedImages = images.map(row => {
            // element is an array, so loop over it
            const rowSelected = row.filter(img => img.selected === true)
            // return row.filter(img => img.selected === true)
            // console.log("ROW SELECTED", rowSelected)
            return rowSelected
        })
        return selectedImages.flat()
    }


    //This will download the images, intraop, botox that are selected
    // const downloadImagesClicked = () => {
    //     let selectedImages = getSelectedImagesList(combinedState)
    //     // console.log("SELECTED IMAGES", selectedImages)

    //     selectedImages.map(img => {
    //         const url=selectImageURL(img)
    //         trackPromise(
    //             downloadURI(url,img.file_name)
    //         )
    //     })
    // }



    const handleClose = () => {
        props.onHide()
    }



    //This is for the selection of images, botox, intraop in the panel, the buttons be disabled if non are chosen
    const onImageClickAll = (event, image) => {
        // toggle selection 
        let images = combinedState
        images = images.map(irow => {
            return irow.map(i => {
                if (i.id === image.id) {
                    return {...i, selected: !i.selected}
                } else {
                    return i
                }
                
            })
        })
        // console.log("IMAGES AFTER SELECTION", image, images)
        setCombinedState([...images])

        // enable/disable buttons
        let selectedImages = getSelectedImagesList(images)

        // if (selectedImages.length > 0) {
        //     // enable buttons
        //     setEnableButtons(true)
        // } else {
        //     // disable buttons
        //     setEnableButtons(false)
        // }

    }


    // check it here: https://stackoverflow.com/questions/70949809/download-image-from-url-on-page-load-using-javascript
    // const downloadURI = (url, name) => {
    //     fetch(url)
    //     .then(resp => resp.blob())
    //     .then(blob => {
    //         const url = window.URL.createObjectURL(blob);
    //         const a = document.createElement('a');
    //         a.style.display = 'none';
    //         // a.href = DOMPurify.sanitize(url)
    //         a.href=url
    //         // the filename you want
    //         a.download = name;
    //         // document.body.appendChild(a);

    //         // console.log("download URI - a", a)
    //         a.click();


    //         // const aa = `<a href="${url}" download="${name}" style="display: none;"></a>`
    //         // console.log("download URI - aa", aa)
    //         // const a2 = DOMPurify.sanitize(aa)
    //         // console.log("download URI - a2", a2)
    //         // a2.click()

            
    //         window.URL.revokeObjectURL(url);
    //     })
    //     .catch((e) => {
    //         // alert('An error sorry ' + e)
    //         setConfirmDialogParams({
    //             show: true,
    //             text: ['Unexpected error during getting the image', 'Please try again', 'If the error persists please contact Support'],
    //             textClass: 'confirmation-text',
    //             // prompt_class: styles['alert-prompt-black'],
    //             cancel_button_text: null,
    //             confirm_button_text: 'OK',
    //             confirm_button_variant: 'primary',
    //             onClose: (result) => setConfirmDialogParams({show:false}),
    //             title: 'Error',
    //             title_class: 'alert-title',
    //             icon: <BsExclamationCircle />
    //         })
    //     });
    // }


    return (
        <>
        <Modal size="fullscreen" show={props.show} onHide={handleClose} animation={false}>
            <Modal.Header closeButton>

            </Modal.Header>

            <Modal.Body>

                <div style={{overflowY: 'auto'}}>
                    <Container fluid >
                        {combinedState.length > 0 && 
                            combinedState.map((img_row, row_ix) => {
                                    return (
                                        <Row key={row_ix} >
                                            {img_row.map((img, img_ix) => {
                                                return (
                                                    <Col className="text-center" xs={12} md={12/columnCount}  key={img.id} >
                                                        <img className={`view-panel-image ${img.selected ? 'view-panel-image-selected' : ''}`}
                                                            src={selectImageURL(img)}
                                                            onClick={(event) => onImageClickAll(event,img) }
                                                            id={`img_${img.id}`}
                                                        />
                                                        <div>{new Date(img.updated_at).toLocaleString('en-US')}</div>
                                                    </Col>
                                                )
                                            })}
                                        </Row>
                                    )
                                })
                        }
                    </Container>
                </div>
            </Modal.Body>

            <Modal.Footer className='justify-content-between'>
                <div className="inline-block text-left"> 
                    <Button className='mx-2' variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
        {/* <LoadingSpinner size='100px' /> */}
        {confirmDialogParams.show &&
            <ConfirmDialog 
                show={confirmDialogParams.show}
                iconColor='red'
                iconSize='2rem'
                icon={confirmDialogParams.icon}
                title={confirmDialogParams.title}
                title_class={confirmDialogParams.title_class}
                text={confirmDialogParams.text}
                textClass={confirmDialogParams.textClass}
                prompt_class={confirmDialogParams?.prompt_class}
                cancel_button_text={confirmDialogParams.cancel_button_text}
                confirm_button_text={confirmDialogParams.confirm_button_text}
                confirm_button_variant={confirmDialogParams.confirm_button_variant}
                onClose={confirmDialogParams.onClose}
                confirm_only={true}
            />
        }
        </>
    )
}

export default ImageViewPanel
